import * as actionTypes from "./actionTypes";
import axios from "axios";
import API from "../../utility/endpoints";
import router from "next/router";
import { sessionTimeOutCheck, checkExpiry } from "../global/actions";

export const fetchGlobalSearchResult = () => {
  return {
    type: actionTypes.FETCH_GLOBAL_SEARCH_RESULT,
  };
};

export const fetchGlobalSearchResultSuccess = (data) => {
  return {
    type: actionTypes.FETCH_GLOBAL_SEARCH_RESULT_SUCCESS,
    payload: data,
  };
};

export const fetchGlobalSearchResultFailed = (data) => {
  return {
    type: actionTypes.FETCH_GLOBAL_SEARCH_RESULT_FAILED,
  };
};

export const globalSearchResult = (payload) => {
  return async(dispatch) => {
    // dispatch(fetchGlobalSearchResult());
    
    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await checkExpiry(authCheck);
         
    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
    return axios({
      method: "get",
      url: `${API.baseUrl}/${API.globalSearch}?k=${payload}`,
      // data: payload,
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
    }).then((resp) => {
      console.log(resp.data.code);
      if (resp.data.code == 200) {
        let keyword = payload;
        resp.data.data;
        dispatch(
          fetchGlobalSearchResultSuccess({ data: resp.data.data, keyword })
        );
        router.push("/globalSearch");
      } else if (resp.data.code == 403) {
        dispatch(fetchGlobalSearchResultFailed());
        dispatch(sessionTimeOutCheck(true));
      } else {
        dispatch(fetchGlobalSearchResultFailed());
      }
    });  } else {
      dispatch(sessionTimeOutCheck(true));
    }
  };
};
